import { ActivityLogSource, AuthenticationApplication } from "@/enums/enums";
import { generateCanvasFingerprint } from "@/helper/canvasFingerprintHelper";
import { AccessToken, RefreshToken } from "@/helper/userHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class AuthenService {
  DoGetAccessToken(
    _input: any,
    source = ActivityLogSource.None,
    otp?: string,
    referenceOtp?: string,
    regenerateOtp = false,
    twoFactorSecretKey?: string,
    recoveryCode?: string
  ) {
    const requestData: any = {
      grant_type: "password",
      client_id: "account",
      client_secret: "accountSecret",
      scope: "payroll.api.full offline_access openid",
      username: _input.userName,
      password: _input.password,
      user_type: _input.userType,
      token: "",
      source: source,
      iss: _input.iss,
      regenerate_otp: regenerateOtp,
    };

    if (recoveryCode) {
      requestData.recovery_code = recoveryCode;
    } else if (otp) {
      requestData.otp = otp;

      if (twoFactorSecretKey) {
        requestData.two_factor_secret_key = twoFactorSecretKey;
        requestData.reference_otp = "";
      } else {
        requestData.reference_otp = referenceOtp || "";
      }
    }

    const data = qs.stringify(requestData);

    // สร้าง canvas fingerprint
    const canvasFingerprint = generateCanvasFingerprint();

    // สร้าง headers พร้อม canvas fingerprint
    const headers: any = {
      "Content-Type": "application/x-www-form-urlencoded",
      ApplicationId: AuthenticationApplication.PeakPayroll,
    };

    // เพิ่ม canvas fingerprint header
    if (canvasFingerprint) {
      headers["x-h-fgp"] = canvasFingerprint;
    }

    return service.peakAuthen
      .post("/connect/token", data, {
        headers,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  }

  DoGetNewAccessTokenByRefreshToken() {
    const data = qs.stringify({
      grant_type: "refresh_token",
      client_id: "account",
      client_secret: "accountSecret",
      refresh_token: RefreshToken(),
    });

    // สร้าง canvas fingerprint
    const canvasFingerprint = generateCanvasFingerprint();

    // สร้าง headers พร้อม canvas fingerprint
    const headers: any = {
      "Content-Type": "application/x-www-form-urlencoded",
      ApplicationId: AuthenticationApplication.PeakPayroll,
    };

    // เพิ่ม canvas fingerprint header
    if (canvasFingerprint) {
      headers["x-h-fgp"] = canvasFingerprint;
    }

    return service.peakAuthen
      .post("/connect/token", data, {
        headers,
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }

  DoGetUserInfo() {
    const headers = {
      Authorization: `Bearer ${AccessToken()}`,
    };
    const params = {};
    return service.peakRealTimeAPIForUser.get("/api/User/GetUserInfoByUserId", { params, headers }).then((res) => {
      return res;
    });
  }
  DoRevokeAccessToken() {
    const accessToken = AccessToken();
    if (accessToken) {
      const data = qs.stringify({
        client_id: "account",
        client_secret: "accountSecret",
        token: accessToken,
        token_type_hint: "access_token",
      });

      return service.peakAuthen
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  }
  DoRevokeRefreshToken() {
    const refreshToken = RefreshToken();
    if (refreshToken) {
      const data = qs.stringify({
        client_id: "ccount",
        client_secret: "accountSecret",
        token: refreshToken,
        token_type_hint: "refresh_token",
      });

      return service.peakAuthen
        .post("/connect/revocation", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          return res;
        })
        .catch((err) => err.response);
    }
  }
  DoIntrospect(token: string) {
    const data = qs.stringify({
      token: token,
    });
    return service.peakAuthen
      .post("/connect/introspect", data, {
        headers: {
          Authorization: `Basic cGF5cm9sbC5hcGk6cGF5cm9sbC5hcGkuc2VjcmV0`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err.response;
      });
  }
  DoRevokeToken(idToken: string, userId: string) {
    const data = qs.stringify({});
    return service.peakAuthen
      .get("/connect/endsession?id_token_hint=" + idToken + "&eui=" + userId, data)
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoGetRefreshTokenExpiration() {
    let refreshToken = RefreshToken();
    if (refreshToken) {
      refreshToken = JSON.stringify(refreshToken);
    }
    return service.peakAuthen
      .post("/token/GetRefreshTokenExpiration", refreshToken, {
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
  DoIntrospectAccessToken() {
    const assetToken = AccessToken();
    const data = qs.stringify({
      client_secret: "account.api.secret",
      client_id: "account.api",
      token: assetToken ? assetToken : "",
    });

    return service.peakAuthen
      .post("/connect/introspect", data, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((res) => {
        return res;
      })
      .catch((err) => err.response);
  }
}

export default new AuthenService();
